var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_5284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9171 2.04492C43.6578 2.04492 41.8262 3.87656 41.8262 6.13583V22.4995C41.8262 24.7587 43.6578 26.5904 45.9171 26.5904C48.1764 26.5904 50.008 24.7587 50.008 22.4995V6.13583C50.008 3.87656 48.1764 2.04492 45.9171 2.04492Z",
    fill: "#D3C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9171 71.5898C43.6578 71.5898 41.8262 73.4215 41.8262 75.6808V83.8626C41.8262 86.1218 43.6578 87.9535 45.9171 87.9535C48.1764 87.9535 50.008 86.1218 50.008 83.8626V75.6808C50.008 73.4215 48.1764 71.5898 45.9171 71.5898Z",
    fill: "#D3C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8276 42.9531H70.464C68.2047 42.9531 66.373 44.7848 66.373 47.044C66.373 49.3033 68.2047 51.1349 70.464 51.1349H86.8276C89.0869 51.1349 90.9185 49.3033 90.9185 47.044C90.9185 44.7848 89.0869 42.9531 86.8276 42.9531Z",
    fill: "#D3C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4634 47.044C25.4634 44.7848 23.6318 42.9531 21.3725 42.9531H5.00888C2.74961 42.9531 0.917969 44.7848 0.917969 47.044C0.917969 49.3033 2.74961 51.1349 5.00888 51.1349H21.3725C23.6318 51.1349 25.4634 49.3033 25.4634 47.044Z",
    fill: "#D3C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7382 15.2256C76.1408 13.6279 73.5505 13.6279 71.9528 15.2256L60.3818 26.7966C58.7842 28.3942 58.7842 30.9843 60.3818 32.5819C61.1806 33.3808 62.2276 33.7803 63.2744 33.7803C64.3214 33.7803 65.3684 33.381 66.1672 32.5819L77.7382 21.0109C79.3358 19.4133 79.3358 16.8232 77.7382 15.2256Z",
    fill: "#D3C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6689 61.5088L14.0984 73.0798C12.501 74.6774 12.501 77.2675 14.0984 78.8651C14.8972 79.664 15.9442 80.0632 16.9912 80.0632C18.0382 80.0632 19.0852 79.664 19.884 78.8651L31.4548 67.2941C33.0521 65.6965 33.0521 63.1064 31.4548 61.5088C29.8569 59.9111 27.2668 59.9111 25.6689 61.5088Z",
    fill: "#D3C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.884 15.2255C18.2863 13.6278 15.6963 13.6281 14.0986 15.2255C12.501 16.8231 12.501 19.4132 14.0986 21.0108L25.6693 32.5818C26.4684 33.3806 27.5152 33.7802 28.5622 33.7802C29.6089 33.7802 30.6562 33.3806 31.4547 32.5821C33.0523 30.9845 33.0523 28.3944 31.4547 26.7967L19.884 15.2255Z",
    fill: "#D3C9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_5284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0.917969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderIcon);
export default __webpack_public_path__ + "static/media/loaderIcon.4065e6a0f5b204ddc5d9d89bcadeab7d.svg";
export { ForwardRef as ReactComponent };